var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, AttachFile, ChevronRightRounded, ExpandLessRounded, InfoOutlined, InsertLinkOutlined, MoreVert } from "@mui/icons-material";
import { SvgIcon, Typography, useMediaQuery } from "@mui/material";
import { nanoid } from "@reduxjs/toolkit";
import { DeleteSvgIcon, DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../assets/customIcons";
import { productListGet } from "../../modules/stockAdjustment/apiCall";
import { showSurface } from "../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../store/hooks";
import { faintblue, faintGray } from "../../theme/palette";
import { getStatusColor } from "../../theme/statusColors";
import ActionMenuList from "../components/actionsMenuList";
import { DynamicFormBuilderContainer } from "../components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import DatagridDemo from "./datagridDemo";
import { RowModeIds } from "../components/editableDataGrid/editableDataGrid.entity";
import TaxDetailsPopup from "../../modules/jobCard/partGridPopups/taxDetailsPopup";
import { labourElements } from "../../modules/jobCardDetails/pages/partAndlabourListData";
var ExampleKeys = {
    Products: 'Products'
};
var sampleQuestions = [{
        id: 1,
        QuestionGroupId: '001',
        Group: 'Question Group 1'
    }, {
        id: 2,
        QuestionGroupId: '001',
        Group: 'Question Group 1',
        QuestionId: 'Q1',
        Name: 'Question 1'
    }, {
        id: 3,
        QuestionGroupId: '001',
        Group: 'Question Group 1',
        QuestionId: 'Q2',
        Name: 'Question 2'
    }, {
        id: 4,
        QuestionGroupId: '002',
        Group: 'Question Group 2'
    }, {
        id: 5,
        QuestionGroupId: '002',
        Group: 'Question Group 2',
        QuestionId: 'Q4',
        Name: 'Question 4'
    }];
var genRandRegNo = function () { return "MH 12 ".concat(nanoid(2).toUpperCase(), " ").concat(Math.floor(Math.random() * 10000).toString().toUpperCase()); };
export var DemoForm = function () {
    var dispatch = useAppDispatch();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    var listDataElements = [{
            type: FormItemTypes.CardComponent,
            name: '',
            md: 6,
            sx: {
                bgcolor: faintblue,
                borderRadius: 2,
                borderColor: faintGray
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'DisplayName',
                    label: 'Part Name :',
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    labelTypographyProps: {
                        variant: 'h6',
                        mb: 0
                    },
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: 'SkuCode',
                    label: 'Part Code :',
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    labelTypographyProps: {
                        variant: 'h6',
                        mb: 0
                    },
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: 'RegNo',
                    label: 'Reg No :',
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    labelTypographyProps: {
                        variant: 'h6',
                        mb: 0
                    },
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'Status',
                    columnSize: true,
                    size: 'small',
                    variant: 'filled'
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    value: null,
                    placeholder: 'Attachments',
                    columnSize: 0,
                    uploadButtonProps: {
                        variant: 'text',
                        startIcon: null,
                        endIcon: /*#__PURE__*/ React.createElement(AttachFile, null)
                    },
                    attachmentButtonProps: {
                        sx: {
                            display: 'none'
                        }
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'SeeMore',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '__filler',
                            columnSize: true
                        }, {
                            type: FormItemTypes.Button,
                            name: 'ViewMore',
                            variant: 'text',
                            size: 'small',
                            children: 'View More',
                            columnSize: 0,
                            sx: {
                                background: 'none'
                            }
                        }],
                    columnSize: 12
                }]
        }];
    var listFormElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            p: 2,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    sm: 12,
                    md: 6,
                    sx: {
                        bgcolor: faintblue,
                        borderRadius: 2,
                        borderColor: faintGray
                    },
                    elements: [{
                            type: FormItemTypes.Chip,
                            name: 'Status',
                            columnSize: 12,
                            containerProps: {
                                container: true,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            size: 'small',
                            variant: 'filled',
                            setFieldProps: function (formValues, currValue) {
                                return _objectSpread({}, getStatusColor(currValue));
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedBy',
                            label: 'Created By :',
                            columnSize: 12,
                            containerProps: {
                                container: true,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                variant: 'h6',
                                mb: 0
                            },
                            variant: 'h6'
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'UOM',
                    label: 'UOM',
                    options: [{
                            id: 'g',
                            Name: 'g'
                        }, {
                            id: 'ml',
                            Name: 'ml'
                        }],
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Rate',
                    label: 'Rate(₹)',
                    xs: 6,
                    required: true,
                    changeTrigger: 'onBlur',
                    setFormState: function (formValues, currValue) {
                        return {
                            TaxesPercentage: currValue < 1000 ? 5 : 12,
                            RateError: currValue < 0 ? 'Rate cannot be negative. Please enter a positive value.' : ''
                        };
                    },
                    // onBlur(e, formValues, formApi) {
                    //     formApi?.handleInputChange?.(e, e.target.value, this)
                    // },
                    // setFieldProps() {
                    //     return {
                    //         onChange: () => { },
                    //     }
                    // },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            error: formValues.RateError
                        };
                    }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Quantity',
                    label: 'Quantity',
                    xs: 6,
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'TaxesAmount',
                    label: 'Taxes (₹)',
                    disabled: true,
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * (Number(formValues === null || formValues === void 0 ? void 0 : formValues.TaxesPercentage) / 100);
                    },
                    xs: 8
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'TaxesPercentage',
                    label: 'Taxes (%)',
                    xs: 3,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.NumberInput,
                        disabled: !Boolean((state === null || state === void 0 ? void 0 : state.Rate) && (state === null || state === void 0 ? void 0 : state.Quantity))
                    }); }
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(SvgIcon, {
                        color: "primary",
                        sx: {
                            height: 20,
                            width: 20
                        }
                    }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                    color: 'secondary',
                    columnSize: 1,
                    setFieldProps: function () {
                        return {
                            disabled: false
                        };
                    },
                    onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            dispatch(showSurface({
                                type: 'Drawer',
                                Component: TaxDetailsPopup,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            px: 0.5,
                                            width: {
                                                xs: '100%'
                                            },
                                            borderRadius: '8px 8px 0 0'
                                        }
                                    },
                                    anchor: 'bottom'
                                },
                                componentProps: {
                                    data: state
                                }
                            }));
                            return [2 /*return*/];
                        });
                    }); }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'DiscountAmount',
                    label: 'Discount (₹)',
                    disabled: true,
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * (Number(formValues === null || formValues === void 0 ? void 0 : formValues.DiscountPercentage) / 100);
                    },
                    xs: 8
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'DiscountPercentage',
                    label: 'Discount (%)',
                    xs: 4,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.NumberInput,
                        disabled: !Boolean((state === null || state === void 0 ? void 0 : state.Rate) && (state === null || state === void 0 ? void 0 : state.Quantity))
                    }); }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'TotalAmount',
                    label: 'Total Amount',
                    disabled: true,
                    valueGetter: function (formValues) {
                        var amount = (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate);
                        var factor = (Number((formValues === null || formValues === void 0 ? void 0 : formValues.TaxesPercentage) || 0) - Number((formValues === null || formValues === void 0 ? void 0 : formValues.DiscountPercentage) || 0)) / 100;
                        var total = (1 + factor) * amount;
                        return Math.fround(total);
                    }
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'StartDate',
                    label: 'Start Date',
                    required: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'EndDate',
                    label: 'End Date',
                    required: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Remarks',
                    multiline: true,
                    minRows: 3,
                    md: 6
                }]
        }];
    var generalTab = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'PRType',
                    label: 'PR Type',
                    options: [{
                            id: 'New'
                        }, {
                            id: 'Rework'
                        }, {
                            id: 'Completed'
                        }],
                    required: true,
                    displayExpr: 'id'
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Department',
                    label: 'Department',
                    options: []
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Supplier',
                    label: 'Supplier',
                    options: []
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'ReferenceNo',
                    label: 'Reference No',
                    validator: function (value, state) {
                        if ((value === null || value === void 0 ? void 0 : value.length) < 5)
                            return 'Min 5 chars needed';
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Priority',
                    label: 'Priority',
                    displayExpr: 'id',
                    options: [{
                            id: 'Low'
                        }, {
                            id: 'Medium'
                        }, {
                            id: 'High'
                        }]
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityReason',
                    label: 'Priority reason (if selected high)',
                    multiline: true,
                    minRows: 3,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.TextInput,
                        required: (state === null || state === void 0 ? void 0 : state.Priority) === 'High',
                        hidden: (state === null || state === void 0 ? void 0 : state.Priority) !== 'High'
                    }); },
                    validator: function (value, state) {
                        if (!value && (state === null || state === void 0 ? void 0 : state.Priority) === 'High')
                            return 'Priority reason is required when Priority is High';
                        return '';
                    }
                }]
        }, isMobile ? {
            type: FormItemTypes.CardComponent,
            name: 'partDetailsMobileView',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    elements: [{
                            type: FormItemTypes.SearchSelect,
                            name: 'Parts',
                            multiple: true,
                            disableCloseOnSelect: true,
                            apiKey: ExampleKeys.Products,
                            getListData: productListGet,
                            renderTags: function () { return null; },
                            clearText: 'Clear Selected Parts',
                            columnSize: true,
                            placeholder: 'Search Parts',
                            setFormState: function (state, value) { return value !== null && value !== void 0 && value.length ? {
                                PartDetailsMobile: value
                            } : {}; },
                            valueGetter: function (state) { return state.PartDetailsMobile; }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'icon',
                            variant: 'outlined',
                            color: 'secondary',
                            disableRipple: true,
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action, PartDetailsMobile, _PartDetailsMobile, _PartDetailsMobile2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.closest('button'),
                                                    slotProps: {
                                                        paper: {
                                                            sx: {
                                                                px: 0.5,
                                                                mt: 0.5
                                                            }
                                                        }
                                                    },
                                                    anchorOrigin: {
                                                        vertical: 'bottom',
                                                        horizontal: 'right'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    }
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: 'Start',
                                                            children: 'Start all'
                                                        }, {
                                                            id: 'Complete',
                                                            children: 'Complete all'
                                                        }, {
                                                            id: 'delete',
                                                            children: "Delete"
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            PartDetailsMobile = state === null || state === void 0 ? void 0 : state.PartDetailsMobile;
                                            if ((action === null || action === void 0 ? void 0 : action.payload) === 'delete') {
                                                PartDetailsMobile = (_PartDetailsMobile = PartDetailsMobile) === null || _PartDetailsMobile === void 0 ? void 0 : _PartDetailsMobile.filter(function (p) { return !p.Selected; });
                                            }
                                            else {
                                                PartDetailsMobile = (_PartDetailsMobile2 = PartDetailsMobile) === null || _PartDetailsMobile2 === void 0 ? void 0 : _PartDetailsMobile2.map(function (p) { return _objectSpread(_objectSpread({}, p), {}, {
                                                    Status: action === null || action === void 0 ? void 0 : action.payload
                                                }); });
                                            }
                                            return [2 /*return*/, {
                                                    PartDetailsMobile: PartDetailsMobile
                                                }];
                                    }
                                });
                            }); }
                        }],
                    xs: 12,
                    sm: 8,
                    md: 6,
                    spacing: 1
                }, {
                    type: FormItemTypes.CheckBox,
                    name: 'SelectAll',
                    label: 'Select All',
                    value: null,
                    columnSize: 12,
                    setFormState: function (state, checked) {
                        var _state$PartDetailsMob;
                        return {
                            PartDetailsMobile: state === null || state === void 0 || (_state$PartDetailsMob = state.PartDetailsMobile) === null || _state$PartDetailsMob === void 0 ? void 0 : _state$PartDetailsMob.map(function (p) { return _objectSpread(_objectSpread({}, p), {}, {
                                Selected: checked
                            }); })
                        };
                    }
                }, {
                    type: FormItemTypes.List,
                    name: 'PartDetailsMobile',
                    columnSize: 12,
                    value: [{
                            id: 0,
                            DisplayName: 'Screw',
                            SkuCode: '#032948',
                            Status: 'Start',
                            RegNo: genRandRegNo()
                        }, {
                            id: 1,
                            DisplayName: 'Break',
                            SkuCode: '#032494',
                            Status: 'Active',
                            RegNo: genRandRegNo()
                        }, {
                            id: 2,
                            DisplayName: 'Tyre',
                            SkuCode: '#037595',
                            Status: 'Rework',
                            RegNo: genRandRegNo()
                        }, {
                            id: 3,
                            DisplayName: 'Mirror',
                            SkuCode: '#037595',
                            Status: 'Awaiting',
                            RegNo: genRandRegNo()
                        }, {
                            id: 4,
                            DisplayName: 'Head Light',
                            SkuCode: '#037595',
                            Status: 'Complete',
                            RegNo: genRandRegNo()
                        }],
                    variant: 'compact',
                    // disableCheckboxSelection: true,
                    // disableDetailsPanel: true,
                    // getRowHeight: () => 'auto',
                    columns: [
                        // {
                        //     field: 'Icon',
                        //     width: 30,
                        //     renderCell: () => <PdfFile />,
                        // },
                        {
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) { /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                fontWeight: "medium"
                            }, params.row.DisplayName), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: "sm",
                                color: "secondary"
                            }, params.row.SkuCode ? params.row.SkuCode : '')); }
                        }
                        // {
                        //     field: 'Delete',
                        //     width: 30,
                        //     renderCell: () => <Delete color='secondary' />,
                        // },
                    ],
                    elements: labourElements,
                    valueGetter: function (formValues, field) {
                        var _formValues$this$name;
                        return (formValues === null || formValues === void 0 || (_formValues$this$name = formValues[this.name]) === null || _formValues$this$name === void 0 ? void 0 : _formValues$this$name.filter(function (item) { return !item.IsDeleted; })) || [];
                    }
                }],
            columnSize: 12,
            containerProps: {
                display: {
                    xs: 'block',
                    sm: 'none'
                }
            }
        } : {
            type: FormItemTypes.Custom,
            name: 'PartDetails',
            value: [{
                    id: RowModeIds.NewRow,
                    IsActive: true
                }],
            label: 'Part details',
            element: function (props) { /*#__PURE__*/ return React.createElement(DatagridDemo, props); },
            columnSize: 12,
            validator: function (value) {
                var errRow = value === null || value === void 0 ? void 0 : value.find(function (r) { return !(r !== null && r !== void 0 && r.Qty); });
                if (errRow)
                    return {
                        id: nanoid(3),
                        rowId: errRow === null || errRow === void 0 ? void 0 : errRow.id,
                        field: "Qty",
                        message: 'Quantity is mandatory'
                    };
                return '';
            },
            containerProps: {
                display: {
                    xs: 'none',
                    sm: 'block'
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'GrandTotal',
                    children: [/*#__PURE__*/ React.createElement(Typography, {
                            color: "inherit",
                            flexGrow: 1,
                            textAlign: "left"
                        }, "Grand Total"), '₹ 00.00'],
                    variant: 'outlined',
                    color: 'secondary',
                    fullWidth: true,
                    sx: {
                        fontWeight: 'strong'
                    },
                    setFieldProps: function (formValues) {
                        return {
                            type: this.type,
                            startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null)
                        };
                    },
                    setFormState: function (formValues, e, field) {
                        return {
                            Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                        };
                    },
                    labelTypographyProps: {
                        display: 'none'
                    }
                }]
        }];
    var additionalInfoTab = [{
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Other information',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: 'ValidDate',
                    label: 'Valid till date',
                    placeholder: 'Select Date',
                    required: true
                }, {
                    type: FormItemTypes.TimePicker,
                    name: 'ValidTime',
                    label: 'Valid till time',
                    placeholder: 'Select time',
                    required: true
                }, {
                    type: FormItemTypes.DateTimePicker,
                    name: 'EstDelDate',
                    label: 'Estimated Delivery Date & Time',
                    required: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    spacing: 0,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'ScheduledDate',
                            label: 'Scheduled for Purchase Order',
                            columnSize: 12,
                            required: true
                        }, {
                            type: FormItemTypes.CheckBox,
                            name: 'IsScheduleForPurchaseOrder',
                            label: 'Schedule Purchase Order',
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Warehouse',
                    label: 'Warehouse',
                    options: [],
                    required: true
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Notes and attachments',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'DeliveryNotes',
                    label: 'Delivery Notes',
                    multiline: true,
                    minRows: 3
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Remarks',
                    multiline: true,
                    minRows: 3
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachment',
                    label: 'Add attachments',
                    value: null,
                    inputProps: {
                        accept: '.pdf',
                        multiple: true
                    },
                    required: true
                }]
        }];
    var tabs = [
        // {
        //     id: '2',
        //     label: 'Details',
        //     elements: mobileDetails,
        // },
        {
            id: '0',
            label: 'General',
            elements: generalTab
        }, {
            id: '1',
            label: 'Additional Info',
            elements: additionalInfoTab
        }
    ];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            p: 2,
            pb: 2,
            spacing: 0,
            rowSpacing: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'headerTitle',
                    columnSize: true,
                    alignItems: 'center',
                    spacing: 0,
                    columnSpacing: 1,
                    flexWrap: 'nowrap',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'back-icon',
                            id: 'back-icon',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'New Purchase Requisition',
                            columnSize: 0,
                            variant: 'h1',
                            noWrap: true
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'StatusName',
                            value: 'Requested',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 0,
                    justifyContent: 'end',
                    flexWrap: {
                        sm: 'nowrap'
                    },
                    spacing: 2,
                    width: {
                        xs: '100%',
                        sm: 'auto'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC DATE: ',
                            children: '17 Oct, 2024',
                            fontSize: 'sm',
                            noWrap: true,
                            xs: 12,
                            sm: 0,
                            md: 0,
                            labelTypographyProps: {
                                color: 'secondary',
                                variant: 'subtitle2',
                                mb: 0,
                                noWrap: true
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                justifyContent: {
                                    xs: 'space-between',
                                    sm: 'end'
                                },
                                gap: 1
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'DOC NO: ',
                            children: 'SSI-13075-2024-00002',
                            fontSize: 'sm',
                            noWrap: true,
                            xs: 12,
                            sm: 0,
                            md: 0,
                            labelTypographyProps: {
                                color: 'secondary',
                                variant: 'subtitle2',
                                mb: 0,
                                noWrap: true
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                justifyContent: {
                                    xs: 'space-between',
                                    sm: 'end'
                                },
                                gap: 1
                            }
                        }]
                }]
        }, _objectSpread(_objectSpread({
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 1.5,
            p: 2,
            justifyContent: 'flex-end',
            bgcolor: {
                xs: 'white',
                sm: 'secondary.100'
            },
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderColor: 'secondary.200'
        }, isMobile ? {
            position: 'fixed',
            zIndex: 10,
            bottom: 0
        } : undefined), {}, {
            elements: __spreadArray(__spreadArray([], (!isMobile ? [{
                    type: FormItemTypes.Button,
                    name: 'quick-links',
                    children: 'Quick Links',
                    columnSize: 0,
                    startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null)
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                    columnSize: 0,
                    color: 'secondary',
                    variant: 'outlined',
                    size: 'icon'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    size: 'icon'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    size: 'icon'
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 0,
                    orientation: 'vertical',
                    sx: {
                        mx: 1
                    }
                }] : []), true), [{
                    type: FormItemTypes.Button,
                    name: 'discard',
                    id: 'discard',
                    children: /*#__PURE__*/ React.createElement(DeleteSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    size: 'icon'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save as draft',
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary',
                    onClick: function () { return 'submit'; },
                    setFormState: function () { return ({
                        Status: 'Draft'
                    }); }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; },
                    setFormState: function () { return ({
                        Status: 'InProgress'
                    }); }
                }], false)
        }), {
            type: FormItemTypes.ErrorsPanel,
            name: 'ErrorsPanel',
            columnSize: 12
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            tabs: tabs,
            valueExpr: 'id',
            displayExpr: 'label',
            columnSize: 12,
            variant: 'scrollable',
            stackContainerProps: {
                px: 2
            }
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "add",
        gridSpacing: 0,
        formProps: {
            bgcolor: 'background.secondary',
            mb: 8
        },
        onChange: function () {
            return {};
        }
    });
};
